import { Button } from "@/components/ui/button";
import {
  StdModal,
  StdModalPresets,
  type StdModalProps,
} from "@/components/ui/modal";
import NiceModal from "@ebay/nice-modal-react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/lab/modal")({
  component: RouteComponent,
});

const DialogPresets: Record<string, () => StdModalProps> = {
  success: (): StdModalProps =>
    StdModalPresets.success({
      title: "Payment successful",
      description: "Your payment has been successfully processed.",
    }),

  successDualAction: (): StdModalProps =>
    StdModalPresets.success({
      title: "Payment successful",
      description:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eius aliquam laudantium explicabo pariatur iste dolorem animi vitae error totam. At sapiente aliquam accusamus facere veritatis.",
      size: "lg",
      actions: [
        {
          label: "Cancel",
          intent: "outline",
          flavor: "gray",
          act: "cancel",
          fullWidth: true,
        },
        {
          label: "OKOK",
          intent: "solid",
          flavor: "accent",
          act: "confirm",
          fullWidth: true,
        },
      ],
    }),

  confirm: (): StdModalProps =>
    StdModalPresets.confirm({
      title: "Deactivate account",
      description:
        "Are you sure you want to deactivate your account? All of your data will be permanently removed. This action cannot be undone.",
      size: "lg",
    }),
};

function RouteComponent() {
  return Object.keys(DialogPresets).map((key) => (
    <Button
      key={key}
      onClick={() => {
        NiceModal.show(StdModal, DialogPresets[key]());
      }}
    >
      {key}
    </Button>
  ));
}
